import match from 'lodash.ismatch';
import type { VariantAction, VariantState } from 'types/variant';

import generateOptions from './generateOptions';
import recoverSelection from './recoverSelection';

export default function reducer(state: VariantState, action: VariantAction) {
    switch (action.type) {
        case 'SET_ATTRIBUTE': {
            const selection = { ...state.selection, ...action.payload };
            const variant = state.variants.filter((v) => match(v, selection));

            if (variant.length === 0) {
                const recoveredSelection = recoverSelection(
                    state.selection,
                    action.payload,
                    state.variants,
                    state.order,
                );
                return {
                    ...state,
                    selection: recoveredSelection,
                    variant: undefined,
                    options: generateOptions(
                        state.attributes,
                        recoveredSelection,
                        state.order,
                    ),
                };
            }

            const options = generateOptions(
                state.attributes,
                selection,
                state.order,
            );

            return {
                ...state,
                selection,
                variant: undefined,
                options,
            };
        }
        case 'SET_VARIANT': {
            if (!action.payload) {
                return state;
            }

            if (state?.variant?.id === action.payload.id) return state;

            const attrs = JSON.parse(action.payload.VariantDefiningAttributes);
            const keys: string[] = Object.keys(attrs);

            const selection: Record<string, string | number> = keys.reduce(
                (a, b) => ({ ...a, [b]: action.payload?.[b] }),
                {},
            );

            return {
                ...state,
                selection,
                variant: action.payload,
                options: generateOptions(
                    state.attributes,
                    selection,
                    state.order,
                ),
            };
        }
        default: {
            throw new Error('VariantContext - Unhandled action type');
        }
    }
}
